import { render } from "./PrologueTemplate.vue?vue&type=template&id=17198ee6&scoped=true&ts=true"
import script from "./PrologueTemplate.vue?vue&type=script&lang=ts"
export * from "./PrologueTemplate.vue?vue&type=script&lang=ts"

import "./PrologueTemplate.vue?vue&type=style&index=0&id=17198ee6&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17198ee6"]])

export default __exports__